import { render, staticRenderFns } from "./TimeApproverTable.vue?vue&type=template&id=d390af24&scoped=true&"
import script from "./TimeApproverTable.vue?vue&type=script&lang=js&"
export * from "./TimeApproverTable.vue?vue&type=script&lang=js&"
import style0 from "./TimeApproverTable.vue?vue&type=style&index=0&id=d390af24&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d390af24",
  null
  
)

component.options.__file = "TimeApproverTable.vue"
export default component.exports